import api from "@/api";
import deepClone from "@/utils/deep-clone";

const state = {
    tokens: [],
};

const getters = {
    tokens(state) {
        return deepClone(state?.tokens ?? []);
    },
};

const actions = {
    getTokens({ commit }) {
        return api.get("/api/api-secrets/").then(res => {
            const tokens = res?.data?.tokens ?? [];

            commit("updateTokens", { tokens });
        });
    },
    generate({ commit }) {
        return api.post("/api/api-secrets/", {}).then(res => {
            const tokens = res?.data?.tokens ?? [];

            commit("updateTokens", { tokens });
        });
    },
    delete({ dispatch }, { payload: { id } }) {
        return api.delete(`/api/api-secrets/${id}`).then(() => {
            return dispatch({ type: "getTokens" });
        });
    },
};

const mutations = {
    updateTokens(state, { tokens }) {
        state.tokens = [...tokens];
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
